import { Box, Flex, Text } from '@chakra-ui/layout'
import React from 'react'

const OProjeto = () => {
  return (
    <Flex maxW="container.md" mr="auto" mx="60px" flexDirection="column" pt={0}>
      {/* <Heading fontSize="4xl" mb={10} mx="auto">O Projeto</Heading> */}
      <Box w="full" mr="auto">
        {/* <Text fontSize="md" my={0}>
          O Laboratório de Práticas Gráficas (LPG) do Departamento de Design da UFPE herdou o
          maquinário e os tipos móveis de metal que foram de Aloísio Magalhães, Gastão de Holanda,
          Orlando da Costa Ferreira e José Laurenio de Melo, grupo conhecido como O Gráfico Amador
          (OGA). Era uma espécie de editora artesanal responsável por, na década de 1950, lançar obras
          de nomes como Hermilo Borba Filho, Ariano Suassuna e Osman Lins em formato de livretos,
          tirando proveito da imagem em diálogo com o texto. <br /> <br />
          Experimentando tipos em homenagem a’O Gráfico Amador foi um convite do LPG, em forma de
          projeto de extensão, a viver a experiência com o acervo e espírito do grupo. Convidamos dez
          estudantes de Design, cinco designers e cinco artistas para utilizar os recursos do laboratório a
          fim de se expressar e explorar linguagens na tradicional técnica de impressão. <br /> <br />
          Os vinte experimentos tipográficos celebram a versatilidade e o vigor estético da tipografia. Além
          da composição manual com os tipos móveis de nosso acervo, os experimentos envolveram a
          utilização de diferentes papéis em variadas gramaturas e diversos materiais usados como
          clichês, como linóleo MDF ou barbante; outros receberam a tinta por carimbo, nanquim ou
          pochoir. <br /> <br />
          Esta, a grande homenagem que prestamos aos mãos sujas d’O Gráfico Amador. Esperamos
          com esse trabalho ter revivido a tradição do grupo recifense, famoso pelo apuro estético e
          inovação gráfica. Não apenas recuperamos a histórica prensa ou retiramos os tipos das caixas e
          os pusemos a trabalhar novamente. O que já seria uma homenagem. Mas tentamos trazer aos
          dias de hoje um fazer artístico pela Tipografia que Aloísio, Gastão, José Laurênio e Orlando
          atingiram há mais de 60 anos atrás. <br /> <br />
        </Text> */}
        <Text fontSize="md" my={0}>
          O Laboratório de Práticas Gráficas (LPG) do Departamento de Design da UFPE herdou o
          maquinário e os tipos móveis de metal que foram de Aloísio Magalhães, Gastão de Holanda,
          Orlando da Costa Ferreira e José Laurenio de Melo, grupo conhecido como O Gráfico Amador
          (OGA). Era uma espécie de editora artesanal responsável por, na década de 1950, lançar obras
          de nomes como Hermilo Borba Filho, Ariano Suassuna e Osman Lins em formato de livretos,
          tirando proveito da imagem em diálogo com o texto. <br /> <br />

          O projeto segue a ideia criada para a exposição <i>Experimentando tipos</i>, realizada em
          2011 por Isabella Ribeiro Aragão e Rosângela Vieira com os tipos da Editora UFPE.
          <i> Experimentando tipos em homenagem a’O Gráfico Amador</i> foi um convite do LPG, em
          forma de projeto de extensão, a viver a experiência com o acervo e espírito do grupo.
          Convidamos dez estudantes de Design, cinco designers e cinco artistas para utilizar os
          recursos do laboratório a fim de se expressar e explorar linguagens na tradicional
          técnica de impressão. <br /> <br />

          Esta, a grande homenagem que prestamos aos mãos sujas d’O Gráfico Amador. Esperamos
          com esse trabalho ter revivido a tradição do grupo recifense, famoso pelo apuro estético e
          inovação gráfica. Não apenas recuperamos a histórica prensa ou retiramos os tipos das caixas e
          os pusemos a trabalhar novamente. O que já seria uma homenagem. Mas tentamos trazer aos
          dias de hoje um fazer artístico pela Tipografia que Aloísio, Gastão, José Laurênio e Orlando
          atingiram há mais de 60 anos atrás. <br /> <br />
        </Text>
        <Text fontSize="md">

        <Text fontWeight="bold" mt={5}>Créditos</Text>
          Coordenação geral Isabella Ribeiro Aragão <br />
          Vice-coordenação Silvio Barreto Campello <br />
          Impressão Maciel Cunha <br />
          Arte educação Luciene Pontes <br />
          Administração Taciana da Fonte <br />
          Assistente de produção Raquel Campello <br />
          Web design Isabella Ribeiro Aragão <br />
          Produção do site Gustavo Albuquerque <br />
          Desenvolvimento do site Henrique Gonçalves <br />
          Audiodescrição Com acessibilidade comunicacional <br />
          Fotografia e vídeo Josivan Rodrigues <br />
          Tratamento das fotos Atelier de Impressão <br />
          Edição de vídeo Leonardo Petty <br />
          Identidade visual e divulgação Felipe Santos <br />
        </Text>
      </Box>
    </Flex>
  )
}

export default OProjeto
